import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const TABS = {
    production: { title: 'Для добывающих', key: 'production' },
    injection: { title: 'Для нагнетательных', key: 'injection' },
};

export const DEBIT_TYPES = {
    production: [
        { value: true, label: 'Средневзвешенный дебит' },
        { value: false, label: 'Среднеарифметический дебит' },
    ],
    injection: [
        { value: true, label: 'Средневзвешенная приёмистость' },
        { value: false, label: 'Среднеарифметическая приёмистость' },
    ],
};

export const SKIP_HOUR_COUNT = {
    production: 100,
    injection: 100,
};

export const DEFAULT_BASE_MONTHS = {
    production: 3,
    injection: 3,
};

export const ALLOWED_NODES = ['well', 'company', 'field', 'pad', 'group', 'profile', 'other', 'license'];

export const DEFAULT_TABLE_DATA = {
    production: { rows: [] },
    injection: { rows: [] },
};

export const DEFAULT_CHARTS_DATA = {
    production: { datasets: {}, range: [], axes: [] },
    injection: { datasets: {}, range: [], axes: [] },
};

export const DEFAULT_FALSE = {
    production: false,
    injection: false,
};

export const DEFAULT_TRUE = {
    production: true,
    injection: true,
};

export const DEFAULT_ARRAY = {
    production: [],
    injection: [],
};

export const DEFAULT_OBJECT = {
    production: {},
    injection: {},
};

export const DEFAULT_NULL = {
    production: null,
    injection: null,
};

export const PERIOD = {
    production: {
        firstDate: {
            date: dayjs().subtract(1, 'month'),
            dateString: dayjs().subtract(1, 'month').format('MM.YYYY'),
        },
        secondDate: {
            date: dayjs(),
            dateString: dayjs().format('MM.YYYY'),
        },
    },
    injection: {
        firstDate: {
            date: dayjs().subtract(1, 'month'),
            dateString: dayjs().subtract(1, 'month').format('MM.YYYY'),
        },
        secondDate: {
            date: dayjs(),
            dateString: dayjs().format('MM.YYYY'),
        },
    },
};
